import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function ApplicationRejectedIllustration() {
  return _jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "160",
    height: "160",
    fill: "none",
    viewBox: "0 0 148 148",
    children: [_jsxs("g", {
      clipPath: "url(#clip0_31126_255906)",
      children: [_jsx("circle", {
        cx: "72.084",
        cy: "73.44",
        r: "63.997",
        fill: "#E6EFFF",
        opacity: "0.7"
      }), _jsx("rect", {
        width: "79.632",
        height: "102.54",
        fill: "#DCE9FE",
        rx: "4.498",
        transform: "scale(-1 1) rotate(7.084 -177.386 -910.488)"
      }), _jsx("path", {
        fill: "#CCDFFF",
        d: "M125.807 112.815l-68.066 8.459a4.497 4.497 0 01-5.018-3.908l-9.86-79.35 76.362 22.945 6.582 51.854z"
      }), _jsx("path", {
        fill: "#fff",
        d: "M108.449 24.593a2.615 2.615 0 00-2.887-2.068L44.536 30.11a2.634 2.634 0 00-2.289 2.942l10.418 83.121a2.634 2.634 0 003.01 2.276l66.305-10.099c1.74-.265 2.734-2.135 2.027-3.748-12.613-28.797-9.402-49.677-15.558-80.008z"
      }), _jsx("path", {
        fill: "#CCDFFF",
        d: "M109.167 27.57a5.632 5.632 0 00-.16-1.288l-.647-5.207-3.247.404.134 1.082c2.377.37 3.403 2.212 3.76 3.721l.16 1.288z"
      }), _jsx("path", {
        fill: "#F0F5FF",
        d: "M110.844 54.283l-58.12 62.278c-.909.973-.083 2.546 1.234 2.35l68.952-10.235a2.234 2.234 0 001.78-2.927c-6.509-19.234-8.705-26.848-11.413-50.65-.136-1.195-1.613-1.695-2.433-.816z"
      }), _jsx("rect", {
        width: "47.765",
        height: "13.177",
        x: "53.734",
        y: "46.996",
        stroke: "#9DC3FF",
        strokeWidth: "1.191",
        rx: "1.406",
        transform: "rotate(-6.478 53.734 46.996)"
      }), _jsx("rect", {
        width: "47.765",
        height: "15.739",
        x: "55.913",
        y: "66.188",
        stroke: "#9DC3FF",
        strokeWidth: "1.191",
        rx: "1.406",
        transform: "rotate(-6.478 55.913 66.188)"
      }), _jsx("path", {
        stroke: "#9DC3FF",
        strokeLinecap: "round",
        strokeWidth: "1.191",
        d: "M70.067 39.572L85.249 37.848"
      }), _jsx("path", {
        stroke: "#9DC3FF",
        strokeLinecap: "round",
        strokeWidth: "1.191",
        d: "M63.176 91.402L99.634 87.262"
      }), _jsx("path", {
        stroke: "#9DC3FF",
        strokeLinecap: "round",
        strokeWidth: "1.191",
        d: "M63.919 97.948L85.648 95.481"
      }), _jsx("path", {
        stroke: "#9DC3FF",
        strokeLinecap: "round",
        strokeWidth: "1.191",
        d: "M91.741 94.79L102.013 93.624"
      }), _jsx("path", {
        stroke: "#9DC3FF",
        strokeLinecap: "round",
        strokeWidth: "1.191",
        d: "M64.662 104.497L74.935 103.331"
      }), _jsx("path", {
        fill: "#B67A4B",
        d: "M31.083 104.906c-1.015 2.916-5.98 8.129-9.905 11.936-2.544 2.466-2.417 6.704.43 8.814 5.194 3.85 9.795 6.537 17.07 7.403 2.07.246 4.035-.866 5.002-2.713 1.046-1.998 2.416-4.767 3.54-7.563 2.138-5.315 14.041-11.578 16.643-15.381 2.602-3.803 6.488-16.8 6.488-16.8l14.998-16.558c.51-.563.476-1.423-.125-1.886-1.465-1.128-4.243-2.878-6.8-2.301-6.286 1.419-12.718 7.883-15.684 11.208-.746.836-2.161.571-2.516-.492l-1.773-5.306c-.206-.617-.195-1.286.083-1.874.711-1.506 2.34-4.452 4.659-5.664 2.234-1.166 7.36 1.158 11.456-.483 1.741-.698 3.526-2.505 4.676-3.841.64-.742.254-1.844-.696-2.08-4.426-1.094-15.163-3.525-19.372-2.478-5.362 1.334-17.674 7.946-21.577 13.65-3.902 5.705-4.868 27.443-6.597 32.409z"
      }), _jsx("path", {
        fill: "#A75925",
        d: "M56.788 83.7l-5.451-14.432 7.224 2.011s.261 4.842 1.852 7.328c.3.468.737.995 1.144 1.449.551.615.523 1.576-.103 2.116l-2.433 2.096a1.406 1.406 0 01-2.233-.569z"
      }), _jsx("path", {
        fill: "#4D91FB",
        d: "M22.12 70.996a1.406 1.406 0 00-1.24 1.554l.345 3.093a1.406 1.406 0 001.553 1.241l60.116-6.716 7.176-3.106c.637-.275.533-1.208-.149-1.336l-7.685-1.446-60.116 6.716z"
      }), _jsx("rect", {
        width: "46.006",
        height: "15.925",
        x: "50.678",
        y: "17.932",
        fill: "#DCE9FE",
        rx: "2.812",
        transform: "rotate(-7.05 50.678 17.932)"
      }), _jsx("circle", {
        cx: "73.507",
        cy: "15.107",
        r: "8.847",
        fill: "#DCE9FE",
        transform: "rotate(-7.05 73.507 15.107)"
      }), _jsx("circle", {
        cx: "73.507",
        cy: "15.105",
        r: "3.539",
        fill: "#fff",
        transform: "rotate(-7.05 73.507 15.105)"
      }), _jsx("path", {
        fill: "#9DC3FF",
        d: "M51.764 26.709l45.658-5.646.523 4.233a2.812 2.812 0 01-2.445 3.136l-40.077 4.956a2.812 2.812 0 01-3.136-2.445l-.523-4.234z"
      }), _jsx("path", {
        stroke: "#9DC3FF",
        strokeWidth: "1.191",
        d: "M101.259 22.932c2.091-.94 6.525-1.506 7.529 3.765 1.254 6.588 5.96 44.547 8.47 53.958"
      }), _jsx("circle", {
        cx: "121.197",
        cy: "106.241",
        r: "7.982",
        fill: "#F96772"
      }), _jsx("path", {
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.255",
        d: "M117.885 103.873l6.902 4.705m-5.961.628l4.392-6.274"
      })]
    }), _jsx("defs", {
      children: _jsx("clipPath", {
        id: "clip0_31126_255906",
        children: _jsx("path", {
          fill: "#fff",
          d: "M0 0H148V148H0z"
        })
      })
    })]
  });
}